module.exports = __webpack_public_path__ + "img/logo.9a5f0232.png";